// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type { PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult } from "./types";

const isNull = (v: unknown): v is null => v === null;

export const isPatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult =
  objectOf<PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult>({
    data: objectOf({
      action_id: number,
      replacement_action_id: anyOf(number, isNull),
    }),
    meta: isNull,
  });
